<template>
  <div class="d-flex-row justify-end gap-0">
    <SidebarTab
      v-for="nav in navs"
      :key="nav.title"
      :action="nav?.action"
      :icon="nav?.icon"
      :to="nav?.to"
      :title="nav?.title"
    />
  </div>
  <NuxtLinkLocale
    :prefetch="false"
    to="/login"
    class="primary filled height-38 width-120 xxl b-radius-35 t-black font-family-1 medium-l f-w-600"
  >
    {{ $t("login.login") }}
  </NuxtLinkLocale>
</template>

<script setup>
import { shallowRef } from "vue";
import UserIcon from "../icons/UserIcon.vue";
import MembershipFilled from "../icons/MembershipFilledIcon.vue";
import BookIcon from "../icons/BookIcon.vue";
import HoodedIcon from "../icons/HoodedIcon.vue";
import ContactIcon from "../icons/ContactIcon.vue";
import SidebarTab from "./SidebarTab.vue";
const { t } = useI18n();
const localePath = useLocalePath();
const router = useRouter();
const currentRoute = router.currentRoute;

const navigateToFAQ = () => {
  const route = currentRoute.value?.meta?.pageInfo?.name || "";
  if (route === "home") {
    const el = document.querySelector(`#${currentRoute.value.query?.to}`);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      const el2 = document.querySelector(`.faq-dummy`);
      el2.scrollIntoView({ behavior: "smooth", block: "end" });
      window.onscrollend = () => {
        const el3 = document.querySelector(`#faq-section`);
        el3.scrollIntoView({ behavior: "smooth" });
        router.replace(localePath("/"));
        window.onscrollend = null;
      };
    }
  } else {
    const path = localePath("/?to=faq-section");
    router.push(path);
  }
};

const navs = computed(() => {
  let mappedNavs = [
    {
      title: t("main.nav.membership"),
      icon: shallowRef(MembershipFilled),
      to: "/membership",
      is_gradient: true,
    },
    {
      title: t("main.nav.answer_hub"),
      icon: shallowRef(BookIcon),
      action: navigateToFAQ,
    },
    {
      title: t("main.nav.work_with_us"),
      icon: shallowRef(HoodedIcon),
      to: "/work-with-us",
    },
    {
      title: t("main.nav.contact"),
      icon: shallowRef(ContactIcon),
      to: "/contact",
    },
  ];

  return mappedNavs;
});
</script>
